import { render, staticRenderFns } from "./PageCalculadoraMatriculacionEsp.vue?vue&type=template&id=e8fa002c&scoped=true&"
import script from "./PageCalculadoraMatriculacionEsp.vue?vue&type=script&lang=js&"
export * from "./PageCalculadoraMatriculacionEsp.vue?vue&type=script&lang=js&"
import style0 from "./PageCalculadoraMatriculacionEsp.vue?vue&type=style&index=0&id=e8fa002c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fa002c",
  null
  
)

export default component.exports